import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";
import { toast } from "sonner";
import type { CreateActividadProgramaInput } from "@/lib/validaciones/createActividadPrograma.validacion";

export const useRegisterActividadPrograma = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateActividadProgramaInput) => {
      const res = await axiosInstance.post("/actividades-programa", data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["actividadesProgramas"] });
      queryClient.invalidateQueries({ queryKey: ["aprendices-con-actividades"] });
      toast.success("Actividad creada exitosamente");
    },
    onError: () => {
      toast.error("Error al crear la actividad");
    },
  });
};
